import client from '../client';
import * as currenciesQueries from "../queries/currency";
import * as currencyMutations from "../mutations/currency";

export function getCurrencies(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: currenciesQueries.all,
    })
    .then(success)
    .catch(error);
}

export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, currency: data },
        mutation: currencyMutations.edit,
    })
    .then(success)
    .catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/currency.js